import { LocalRoutes } from '../../utilities/LocalRoutes';
import { useQuery } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';

export const useGetExpertKey = 'get-expert';

export const useGetExpert = (guid?: string) => {
    const { zoneApiClient, zoneNavigate} = useZoneContext();
    
    return useQuery({
        queryKey: [useGetExpertKey, guid],
        queryFn: async ({ queryKey }) => {
            const [, expertGuid] = queryKey;
            const response = await zoneApiClient.getExpertById(expertGuid ?? '');
            
            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve this expert.');
            }
            if (response.httpResponse.status === 403) {
                zoneNavigate(LocalRoutes.AccessDenied);
            }

            return response.payload;
        },
        enabled: !!guid,
    });
}
    